import React, { useState } from 'react';

import classNames from 'classnames';

import { useSubjectsQuery } from '@school_ify/schoolify-repository/src/shared/types';

import DropDown from 'clean/components/common/DropDown/DropDown';
import SelectCyrcles from 'clean/components/common/SelectCyrcles/SelectCyrcles';
import Icon from 'components/Icon/Icon';

import styles from './Filters.module.scss';

const Filters: React.FC = () => {
  const { data: subjects } = useSubjectsQuery();

  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const iconName = subjects?.subjects.find(item => item?.id === selectedSubject)?.icon;
  const [classes2] = React.useState([
    { id: 1, label: '1A' },
    { id: 2, label: '2A' },
    { id: 3, label: '3A' },
    { id: 4, label: '4A' },
    { id: 5, label: '5A' },
    { id: 6, label: '6A' },
    { id: 7, label: '7A' },
    { id: 8, label: '8A' },
    { id: 9, label: '9A' },
    { id: 10, label: '10A' },
    { id: 11, label: '11A' },
    { id: 12, label: '12A' },
    { id: 13, label: '13A' },
    { id: 14, label: '14A' },
    { id: 15, label: '15A' },
    { id: 16, label: '16A' },
    { id: 17, label: '17A' },
    { id: 18, label: '18A' },
    { id: 21, label: '21A' },
    { id: 22, label: '22A' },
    { id: 23, label: '23A' },
    { id: 24, label: '24A' },
    { id: 25, label: '25A' },
    { id: 26, label: '26A' },
    { id: 27, label: '27A' },
    { id: 28, label: '28A' },
    { id: 29, label: '29A' },
    { id: 210, label: '210A' },
    { id: 211, label: '211A' },
    { id: 212, label: '212A' },
    { id: 213, label: '213A' },
    { id: 214, label: '214A' },
    { id: 215, label: '215A' },
    { id: 216, label: '216A' },
    { id: 217, label: '217A' },
    { id: 218, label: '218A' },
  ]);
  return (
    <div className={styles.markFilters}>
      <div className={styles.filterSubject}>
        <div className="text-label">Subject</div>
        <div className="">
          <DropDown
            labelProperty="name"
            value={selectedSubject}
            inputClassName={styles.subjectInput}
            onChange={setSelectedSubject}
            emptyItemLabel="- All subjects -"
            options={subjects?.subjects || []}
            iconStart={iconName && <Icon name={iconName} />}
            renderRow={({ item: subject, classes: defaultClasses, onClick, isSelected }) => {
              return (
                <div
                  onClick={() => onClick(subject)}
                  className={classNames(defaultClasses.outer, {
                    [defaultClasses.outerSelected]: isSelected,
                  })}
                >
                  <div className={defaultClasses.inner}>
                    {subject.icon && <Icon name={subject.icon} className={styles.icon} />}
                    {subject.name}
                  </div>
                </div>
              );
            }}
          />
        </div>
      </div>
      <div className={styles.filterClass}>
        <div className="text-label" style={{ marginBottom: '8px' }}>
          Classes
        </div>
        <SelectCyrcles
          options={classes2}
          value={selectedClass}
          onChange={value => {
            setSelectedClass(value);
          }}
        />
      </div>
      <div className={styles.filterSubject}>
        <div className="text-label">Period</div>
        <div className="">
          <DropDown
            labelProperty="name"
            value={selectedSubject}
            inputClassName={styles.subjectInput}
            onChange={setSelectedSubject}
            emptyItemLabel="- All subjects -"
            options={subjects?.subjects || []}
            iconStart={iconName && <Icon name={iconName} />}
            renderRow={({ item: subject, classes: defaultClasses, onClick, isSelected }) => {
              return (
                <div
                  onClick={() => onClick(subject)}
                  className={classNames(defaultClasses.outer, {
                    [defaultClasses.outerSelected]: isSelected,
                  })}
                >
                  <div className={defaultClasses.inner}>
                    {subject.icon && <Icon name={subject.icon} className={styles.icon} />}
                    {subject.name}
                  </div>
                </div>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Filters;
